
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Info } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useChangelog } from "./useChangelog";

export const ChangelogTab = () => {
  const { currentVersion, changelog, hasNewVersion } = useChangelog();

  return (
    <Card>
      <CardContent className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-medium">Version History</h2>
            <p className="text-sm text-muted-foreground">
              Current version: {currentVersion}
            </p>
          </div>
          {hasNewVersion && (
            <Badge variant="default" className="bg-green-500">New</Badge>
          )}
        </div>

        {hasNewVersion && (
          <Alert>
            <Info className="h-4 w-4" />
            <AlertTitle>New Version Available</AlertTitle>
            <AlertDescription>
              A new version of the application is available with new features and improvements.
            </AlertDescription>
          </Alert>
        )}

        <ScrollArea className="h-[400px] rounded-md border p-4">
          {changelog.map((entry) => (
            <div key={entry.version} className="mb-6 last:mb-0">
              <div className="flex items-center gap-2 mb-2">
                <h3 className="font-medium">Version {entry.version}</h3>
                <Badge variant="outline">{entry.date}</Badge>
              </div>
              <ul className="list-disc pl-5 space-y-1">
                {entry.changes.map((change, index) => (
                  <li key={index} className="text-sm text-muted-foreground">
                    {change}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </ScrollArea>
      </CardContent>
    </Card>
  );
};
